<template>
  <div class="Reports px-4">
    <v-snackbar
      v-model="snackbar.show"
      :timeout="snackbar.timeout"
      top
      :color=snackbar.color
      rounded
      centered
    >
      {{ snackbar.text }}
    </v-snackbar>
    <v-snackbar
      v-model="showSurveySnackbar"
      :timeout="2000"
      top
      color="green"
      rounded
      centered
    >
      <p class="mb-0 text-center">{{ $t('SatisfactionSurveyModal.thankYou') }}</p>
    </v-snackbar>
    <SatisfactionSurveyModal
      v-if="satisfactionSurveyModal"
      :dialog.sync="satisfactionSurveyModal"
      :questions="SATISFACTION_SURVEY_QUESTIONS"
      :declineBtnCallback="declineSatisfactionSurvey"
      :confirmBtnCallback="saveSatisfactionSurveyResponse"
      :functionality="FUNCTIONALITY"
    />
    <v-container>
        <Header
          :reportDates="organizationData.reportDates"
          :orgInfo="organizationData.orgInfo"
          v-on:changeReport="changeReportHandler"
          :cardsData="headerCardsData"
          :loadingQuery="$apollo.queries.organizationData.loading"
          :date="date"
        ></Header>

        <v-container fluid class="CardsHeader d-flex pa-0 mt-5 mb-3">
          <span>{{$t("Reports.equipmentPerformance")}}</span>
          <v-spacer></v-spacer>
          <!-- <v-btn round class="mx-0">COMPARAR</v-btn> -->
        </v-container>

        <v-container
          v-if="$apollo.queries.equipmentsData.loading"
          fluid
          class="display-1 text-center mt-5"
        >
          <v-progress-circular
            indeterminate
            color="#0098E1"
          ></v-progress-circular>
        </v-container>
        <v-container
          v-else-if="validEquipments.length === 0"
          fluid
          class="display-1 text-center grey--text"
        >
          {{$t("Reports.noReports")}}
        </v-container>
        <template v-else>
          <MainCard
            v-for="equip in validEquipments"
            :id="`${equip.id}-main-card`"
            :key="equip.id"
            :equipData="equip.equipData"
            :locations="equip.locations"
            :badgesInfo="equip.badges"
            :lot="lot"
            :deviceId="deviceId"
            :firstLoad="firstScroll"
            :faultsEvery100hsAverage="faultsEvery100hsAverage"
          ></MainCard>
        </template>
    </v-container>
  </div>
</template>

<script>
import Header from './Header'
import MainCard from './MainCard'
import gql from 'graphql-tag'
import { getAveragePressure, getNumFaults, getHomogeneityCoef, parseIOReportCsvData } from '../../lib/reportsValuesGetters'
import SatisfactionSurveyModal from '../Shared/SatisfactionSurveyModal.vue'
import { SATISFACTION_SURVEY } from '../../constants/const'
import { updateSatisfactionSurveyInfo, saveSatisfactionSurveyResponse, showSatisfactionSurvey } from '../../lib/satisfaction-surveys'
import { firestore } from '../../plugins/firebase'

export default {
  data () {
    return {
      organizationData: {reportDates: [], orgInfo: {}},
      equipmentsData: [],
      reportId: '',
      firstTime: true,
      deviceId: this.$route.query.device,
      date: this.$route.query.date,
      lot: this.$route.query.lot,
      firstScroll: true,
      urlReportFounded: true,
      reportNotFoundNotified: false,
      snackbar: {
        show: false,
        timeout: 3000,
        text: ''
      },
      satisfactionSurveyModal: false,
      SATISFACTION_SURVEY_QUESTIONS: [{
        text: 'utility',
        type: SATISFACTION_SURVEY.QUESTION_TYPE.RATING
      }, {
        text: 'why',
        type: SATISFACTION_SURVEY.QUESTION_TYPE.OPTIONS,
        options: [
          SATISFACTION_SURVEY.OPTIONS.INACCURATE_DATA,
          SATISFACTION_SURVEY.OPTIONS.CONFUSING_INFO,
          SATISFACTION_SURVEY.OPTIONS.MISSING_DATA,
          SATISFACTION_SURVEY.OPTIONS.OTHER
        ]
      }],
      satisfactionSurveyId: undefined,
      FUNCTIONALITY: SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS,
      showSurveySnackbar: false,
      faultsEvery100hsAverage: null
    }
  },
  components: {
    Header,
    MainCard,
    SatisfactionSurveyModal
  },
  async created () {
    // Update satisfaction survey info
    const {count, lastActivityDate} = await updateSatisfactionSurveyInfo(SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS)
    showSatisfactionSurvey(count, lastActivityDate, SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS).then(shouldShow => {
      if (shouldShow) {
        this.satisfactionSurveyModal = true
      }
    })
    const db = await firestore
    this.faultsEvery100hsAverage = (await db.collection('app/v1/constants').doc('reports').get()).data().faultsEvery100hsAverage
  },
  methods: {
    changeReportHandler (reportId) {
      if (reportId) {
        this.$apollo.queries.equipmentsData.refetch({reportId})
      }
      this.firstTime = false
      this.equipmentsData = []
    },
    alertURLReportNotFound () {
      if (!this.reportNotFoundNotified) {
        this.urlReportFounded = false
        this.reportNotFoundNotified = true
        this.snackbar = {
          ...this.snackbar,
          show: true,
          text: this.$t('Reports.urlReportNotFound'),
          color: 'red'
        }
      }
    },
    async saveSatisfactionSurveyResponse (question, response) {
      await updateSatisfactionSurveyInfo(SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS, true)
      const surveyId = await saveSatisfactionSurveyResponse(this.satisfactionSurveyId, this.$store.getters.user, SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS, question, response)
      this.satisfactionSurveyId = surveyId
    },
    async declineSatisfactionSurvey () {
      await updateSatisfactionSurveyInfo(SATISFACTION_SURVEY.FUNCTIONALITIES.REPORTS, true)
    }
  },
  computed: {
    organizationId () {
      return this.$store.getters.selectedOrganization.id
    },
    validEquipments () {
      let validEquipments = this.equipmentsData.filter(equip => (equip.locations && equip.locations.length > 0))
      validEquipments = validEquipments.sort((a, b) => {
        const aEqName = a.equipData.name.toUpperCase()
        const bEqName = b.equipData.name.toUpperCase()
        return aEqName.localeCompare(bEqName, undefined, {numeric: true, sensitivity: 'base'})
      })
      return validEquipments
    },
    headerCardsData () {
      let totalHours = 0
      let totalFaults = 0
      let pressureState = true
      if (this.equipmentsData.length === 0) {
        return null
      }
      this.equipmentsData.forEach(equip => {
        if (equip.locations) {
          equip.locations.forEach(loc => {
            let pressureVal = NaN
            // Hours and faults
            if (loc.details && loc.details.data) {
              if (loc.details.data.irrigation_hours) {
                totalHours += parseFloat(loc.details.data.irrigation_hours)
              }
              if (loc.details.data.num_faults) {
                totalFaults += loc.details.data.num_faults
              }
              pressureVal = parseFloat(loc.details.data.average_pressure)
            }
            // Pressure
            const bookPres = parseFloat(loc.circularGraphics.book_pressure)
            if (pressureState) {
              if (isNaN(bookPres) || isNaN(pressureVal) || !((pressureVal >= (bookPres - 0.5)) && (pressureVal <= (bookPres + 0.5)))) {
                pressureState = false
              }
            }
          })
        }
      })
      return {totalHours, totalFaults, pressureState}
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    }
  },
  apollo: {
    $client: 'reportsClient',
    organizationData () {
      const userRoles = this.$store.getters.userRoles
      const checkedFilter = userRoles && userRoles.isAdmin ? '' : 'is_published_not: false'
      return {
        query: gql`query getReportDates($organizationIdString: String, $organizationId: String!) {
          allReports(where: {
            organization_ends_with: $organizationIdString,
            ${checkedFilter}
          }, sortBy: [id_DESC]){
            id
            from_date
            to_date
            is_published
          }
          singleOrg(organizationId: $organizationId) {
            id
            name
          }
        }`,
        update: data => {
          return {
            reportDates: data.allReports,
            orgInfo: data.singleOrg
          }
        },
        skip () {
          return !this.organizationId
        },
        variables () {
          return {
            organizationIdString: this.organizationId + '"}',
            organizationId: this.organizationId
          }
        }
      }
    },
    equipmentsData: {
      query: gql`query getReportData($reportId: ID!) {
        singleFullReport(reportId: $reportId){
          id
          from_date
          to_date
          report_items{
            location{
              name
              area
              position
              zoom
              equipment{
                id
                name
                model
                brand
                length
                equipmentArea,
                pumpFlow
              }
            }
            id
            is_checked
            metrics{
              id
              # homogeneity_coef
              mod_homogeneity_coef
              # faults_every_hundred
              mod_faults_every_hundred
              time_against_faults
              mod_time_against_faults
              irrigation_orders_compliance
              mod_irrigation_orders_compliance
            }
            details {
              id
              application_rate
              irrigation_hours
              # num_faults
              # average_pressure
              accumulated_application_rate
              completed_passes
            }
            description {
              crop
              watering_employee
              field
              zone
              equip_num_pumps
              equipment_comment
              location_comment
            }
            circular_graphics{
              pressure_data
              book_pressure
              homogeneity_data
              faults{
                id
                code
                from_angle
                to_angle
                duration
                start
                end
                is_pump_type
                recover_time
                details
              }
              io_report_data
              io_report_items{
                id
                doc
                emission_date
                code
                transmitter
                millimeters
                start
                end
                application_rate
                passes
                unordered_irrigation
              }
            }
            linear_graphics{
              irrigation_data
              movement_data
            }
          }
        }
      }`,
      variables () {
        return {
          reportId: this.reportId
        }
      },
      skip () {
        return this.firstTime
      },
      update (data) {
        const equipments = {}
        const userRoles = this.$store.getters.userRoles
        data.singleFullReport.report_items.forEach(({is_checked: isChecked, location, ...reportItem}) => {
          if (isChecked || (userRoles && userRoles.isAdmin)) {
            const {equipment, ...locData} = location
            const {metrics, description, details, circular_graphics: circularGraphics, linear_graphics: linearGraphics, ...itemData} = reportItem

            const saveEquip = () => {
              equipments[equipment.id] = {
                equipData: {
                  name: equipment.name,
                  model: equipment.model,
                  brand: equipment.brand,
                  id: equipment.id,
                  pumpFlow: equipment.pumpFlow,
                  equipmentArea: equipment.equipmentArea
                },
                locations: [
                  ...((equipments[equipment.id] && equipments[equipment.id].locations) || {}),
                  {
                    // id: locData.id,
                    id: locData.name,
                    name: locData.name,
                    isChecked,
                    ...itemData,
                    metrics: metrics && [{ // Coef. de homogeneidad
                      value: getHomogeneityCoef(circularGraphics),
                      mod: {
                        value: parseFloat(metrics.mod_homogeneity_coef)// Porcentaje
                      }
                    }, { // Fallas cada 100hs
                      mod: {
                        value: parseFloat(metrics.mod_faults_every_hundred)// Porcentaje
                      }
                    }, { // Tiempo de respuesta ante fallas
                      value: parseFloat(metrics.time_against_faults), // Cantidad de segundos
                      mod: {
                        value: parseFloat(metrics.mod_time_against_faults)// Cantidad de segundos
                      }
                    }, { // Cumplimiento de las ordenes de riego
                      value: parseFloat(metrics.irrigation_orders_compliance),
                      mod: {
                        value: parseFloat(metrics.mod_irrigation_orders_compliance)// Porcentaje
                      }
                    }],
                    details: {
                      equipment_comment: description && description.equipment_comment,
                      location_comment: description && description.location_comment,
                      description: {
                        crop: description && description.crop,
                        num_pumps: description && description.equip_num_pumps,
                        field: description && description.field,
                        area: parseFloat(locData.area),
                        zone: description && description.zone,
                        watering_employee: description && description.watering_employee
                      },
                      data: {
                        ...details,
                        num_faults: getNumFaults(circularGraphics),
                        average_pressure: getAveragePressure(circularGraphics)
                      }
                    },
                    circularGraphics: {
                      // real_image: locData.real_image && locData.real_image.publicUrl,
                      // altimetry: locData.altimetry_image && locData.altimetry_image.publicUrl,
                      position: locData.position && JSON.parse(locData.position),
                      zoom: locData.zoom,
                      equipLength: equipment.length,
                      ...circularGraphics,
                      ...parseIOReportCsvData(circularGraphics)
                    },
                    linearGraphics: {
                      ...linearGraphics
                    }
                  }
                ]
              }
            }
            const devicesPermissions = this.userPermissions[this.organizationId]
            const userRoles = this.$store.getters.userRoles

            if (this.organizationId === this.$store.getters.userOrganization.id || (userRoles && userRoles.isAdmin)) {
              saveEquip() // If the selected organization is the user organization or the user is admin, every equipment are allowed
            } else if (!(userRoles && userRoles.farmhand) && Array.isArray(devicesPermissions)) {
              if (devicesPermissions.length === 0) {
                saveEquip() // If the devicePermissions is empty, it means the user has access to every equipment (organization permission)
              } else if (devicesPermissions.includes(equipment.id)) {
                saveEquip() // If there are device permissions, it should be checked if the user has access to it
              }
            }
          }
        })

        const returnData = Object.entries(equipments).map(([id, data]) => ({id, ...data}))
        return returnData
      }
    }
  },
  watch: {
    validEquipments (val) {
      // If URL parameters were not entered, do not search the report
      if (!this.deviceId) return

      if (val.length && this.firstScroll && this.urlReportFounded) {
        setTimeout(() => {
          const element = document.getElementById(`${this.deviceId}-main-card`)

          // If device was not found, show the error into the snackbar
          if (!element) return this.alertURLReportNotFound()

          const toolbarHeight = document.getElementById('toolbar').clientHeight + 10
          var elementPosition = element.getBoundingClientRect().top
          var offsetPosition = elementPosition + window.scrollY - toolbarHeight

          // Scroll to device card
          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
          })
          this.firstScroll = false
        }, 200)
      }
    },
    satisfactionSurveyModal (val) {
      if (!val && this.satisfactionSurveyId) {
        // If the survey was completed, show thank you snackbar
        this.showSurveySnackbar = true
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Reports.vue?578b7785